module.exports = __webpack_public_path__ + "img/50-51.52d2852a.png";